import { useAuthFetchWithResponse } from '@e3dc-react/shell/Hooks/AuthFetch'
import { useApiResultQuery } from 'src/Libs/api'
import { useTypedSelector } from 'src/State/RootReducer'
import { getFileFavorites } from '../api'
import { FileFavoritesModel } from '../models'
import { useUserRoles } from 'src/Hooks/user'

/**
 * Hook to get all files for download section
 */
export const useFileFavorites = (): [FileFavoritesModel[] | undefined, number[], boolean, boolean] => {
  const authFetch = useAuthFetchWithResponse()
  const refresh = useTypedSelector(state => state.apiView.refresh)
  const { isServiceUser } = useUserRoles()

  const { data, isError, isLoading } = useApiResultQuery({
    queryKey: ['file-favorites', refresh],
    fetchFunction: () => getFileFavorites(authFetch),
    options: {
      staleTime: 0,
      enabled: !isServiceUser,
    },
  })

  if (isError) {
    return [undefined, [], isLoading, isError]
  }

  const favoriteFileIds = data ? data.map(d => d.downloadItemId) : []

  return [data, favoriteFileIds ?? [], isLoading, isError]
}
